import { ENV } from '../config/keys';

export const debugLog = (msg: string) => {
    if (ENV !== 'production') {
        console.log(msg);
    } 
};
